import { useContext } from 'react'
import { PageContext } from '../../../contexts/page-context'
import { gnarSpec } from '../../../lib/tracking/gnar'
import { ButtonCta } from '../../ui-lib/button'
import { ExternalLink } from '../../ui-lib/link'

import styles from './company-announcement.module.scss'
import { useBannerShow } from '../../../lib/hooks'

const BANNER_URL = 'https://www.grammarly.com/blog/company/grammarly-to-acquire-superhuman'
const BANNER_ID = 'Company Announcement Jul 30, 2025'

export const CompanyAnnouncementBanner = () => {
  const { pageId, slug } = useContext(PageContext)

  useBannerShow(true, BANNER_ID, BANNER_URL)

  return (
    <aside className={styles.banner}>
      <ExternalLink
        className={styles.bannerLink}
        target="_blank"
        href={BANNER_URL}
        onClick={() => {
          void gnarSpec.bannerClick(BANNER_ID, pageId, slug, BANNER_URL)
        }}
      >
        Grammarly to acquire Superhuman
        <ButtonCta className={styles.bannerButton} text="Learn more" showArrow padding="compact" />
      </ExternalLink>
    </aside>
  )
}
